<div class="fulfillmentLanding container-return-wrapper associate-crop-landing">
  <div class="containerReturnsLandingPage">
    <div class="row">
      <div class="col-12 mb-3">
        <h3>
          Proving Ground Seed Order Inquiry
        </h3>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (exportClick)="export()" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div>
        <button mat-raised-button class="btns xs-button xs-full-width exportBtn" [disabled]="(dataSource && dataSource.data.length == 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <div class="d-flex justify-content-end btnWrap">
          <button *ngIf="showCreateButton" mat-raised-button class="btns newOrderBtn" color="primary" (click)="createNewOrder()">Create New Order</button>
        </div>
        <mat-tab-group class="matTabs prepayLandingTab">
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Proving Ground Seed Orders
                </h4>
                <p class="subhead">
                  View Your Proving Ground Seed Orders
                </p>
              </div>
            </ng-template>

            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4"></div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #pgsPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>

            <div class="tableContainer activeReturnRequest">
              <table mat-table [dataSource]="dataSource" matSort #pgsSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Web Order Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="navigateOrderDetail(element)">
                      <u>
                        <p class="accNo">
                          {{element.webOrderNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="salesManagerAccountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Sales Manager Account</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.salesManagerAccountNumber}}</td>
                </ng-container>

                <ng-container matColumnDef="salesManagerAccountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Sales Manager Name</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.salesManagerAccountName}}</td>
                </ng-container>

                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.accountNumber}}</td>
                </ng-container>

                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.accountName}}</td>
                </ng-container>

                <ng-container matColumnDef="parentAccountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Parent Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.parentAccountNumber}}</td>
                </ng-container>

                <ng-container matColumnDef="parentAccountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Parent Account Name</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.parentAccountName}}</td>
                </ng-container>

                <ng-container matColumnDef="productLine">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Product Line</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.productLine}}</td>
                </ng-container>

                <ng-container matColumnDef="packName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Pack Name</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="openPackDetails(element)">
                      <u>
                        <p class="accNo">
                          {{element.packName}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Order Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.orderDate | date:'MM/dd/yyyy'}}</td>
                </ng-container>

                <ng-container matColumnDef="orderedQuantity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ordered Quantity</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.orderedQuantity | number:'1.0-0'}}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-left">{{element.status}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>

              <div *ngIf="!dataSource || dataSource.data.length === 0" class="noDataMsg">
                <p class="padding-b47">No Proving Ground Seed orders were found for the selected search criteria.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

<div class="pack-modal-backdrop" *ngIf="showPackModal">
  <div class="pack-modal-body" role="dialog" aria-modal="true" aria-labelledby="pack-modal-title">
    <div class="pack-modal-header">
      <h4 id="pack-modal-title" class="m-0">{{selectedPackName}}</h4>
      <button type="button" class="pack-modal-close" (click)="closePackModal()" aria-label="Close">
        <span class="pack-close-icon" aria-hidden="true"></span>
      </button>
    </div>

    <div class="tableContainer">
      <table mat-table [dataSource]="selectedPackDetails" class="matTables containerDrafTable pack-table">
        <ng-container matColumnDef="itemNumber">
          <th mat-header-cell *matHeaderCellDef class="text-center">Item Number</th>
          <td mat-cell *matCellDef="let element" class="text-center">{{element.itemNumber}}</td>
        </ng-container>

        <ng-container matColumnDef="hybridVariety">
          <th mat-header-cell *matHeaderCellDef class="text-center">Hybrid Variety</th>
          <td mat-cell *matCellDef="let element" class="text-center">{{element.hybridVariety}}</td>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef class="text-center">Quantity</th>
          <td mat-cell *matCellDef="let element" class="text-center">{{element.quantity}}</td>
        </ng-container>

        <ng-container matColumnDef="uom">
          <th mat-header-cell *matHeaderCellDef class="text-center">UOM</th>
          <td mat-cell *matCellDef="let element" class="text-center">{{element.uom}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="packDisplayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: packDisplayedColumns"></tr>
        <tr *matNoDataRow>
          <td class="mat-mdc-cell pack-no-records" [attr.colspan]="packDisplayedColumns.length">
            No Record Found.
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
